import { render, staticRenderFns } from "./OrderTemplate.vue?vue&type=template&id=35ee747c&"
import script from "./OrderTemplate.vue?vue&type=script&lang=js&"
export * from "./OrderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports